// extracted by mini-css-extract-plugin
export default {"ClosedOrderListPage":"ClosedOrderListPage_ClosedOrderListPage__gmSzQ"};